import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const faqs = [{
  q: '¿Realmente funciona si me bloqueó?',
  a: "No enviamos mensajes a cuentas bloqueadas, pero el manual te enseña cómo usar el 'Misterio Indirecto' para que vuelvan a buscarte y te desbloqueen por curiosidad."
}, {
  q: '¿Tengo que ser un experto en tecnología?',
  a: "No, son plantillas de texto simples que puedes usar en WhatsApp, iMessage o Instagram. La 'IA' está en la lógica detrás de los mensajes, no en el software que usas."
}, {
  q: '¿Qué pasa si no funciona?',
  a: 'Habrás recuperado tu dignidad y autonomía, lo cual te pone en una mejor posición para tu próxima relación. Dejarás de sentirte como la víctima.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 relative" data-id="element-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <FadeIn data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-23">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-25">
              <div className="bg-glass border border-white/10 rounded-xl overflow-hidden" data-id="element-26">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-27">
                  <span className="font-bold text-lg" data-id="element-28">{faq.q}</span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.2
              }} data-id="element-29">
                    <ChevronDown className="w-5 h-5 text-[#00d9ff]" data-id="element-30" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-31">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-32">
                      <div className="px-6 pb-5 text-gray-400" data-id="element-33">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}